import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { apiErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function AdminLogin() {
  const { login, googleLogin, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Handle Google OAuth callback (session_id in hash)
    const hash = window.location.hash;
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
      if (sid) {
        setLoading(true);
        googleLogin(sid)
          .then(() => { window.history.replaceState(null, "", "/admin"); nav("/admin"); })
          .catch((e) => { toast.error(apiErr(e)); setLoading(false); });
      }
    }
  }, []);

  useEffect(() => { if (user && user.role === "admin") nav("/admin"); }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error(apiErr(err));
      setLoading(false);
    }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/login";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background p-4">
      <div className="w-full max-w-md rounded-3xl bg-card cb-card-shadow p-8">
        <div className="flex flex-col items-center mb-8">
          <span className="grid place-items-center h-14 w-14 rounded-2xl cb-gradient text-primary-foreground mb-3">
            <Sparkles className="h-7 w-7" />
          </span>
          <h1 className="font-display text-2xl font-bold">Cloud Beauty</h1>
          <p className="text-muted-foreground text-sm mt-1">لوحة تحكم الإدارة</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="mb-1.5 block">البريد الإلكتروني</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-xl h-12" dir="ltr" data-testid="admin-email-input" />
          </div>
          <div>
            <Label className="mb-1.5 block">كلمة المرور</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-xl h-12" dir="ltr" data-testid="admin-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full h-12 font-bold" data-testid="admin-login-submit">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Lock className="h-4 w-4 me-2" /> تسجيل الدخول</>}
          </Button>
        </form>

        <div className="flex items-center gap-3 my-5">
          <div className="h-px bg-border flex-1" /><span className="text-xs text-muted-foreground">أو</span><div className="h-px bg-border flex-1" />
        </div>
        <Button type="button" variant="outline" onClick={google} className="w-full rounded-full h-12 border-2 font-semibold" data-testid="admin-google-login">
          <img src="https://www.google.com/favicon.ico" alt="" className="h-4 w-4 me-2" /> الدخول عبر Google
        </Button>
      </div>
    </div>
  );
}
